'use client';
import React from 'react';
import { useMemo } from "react";
import { PiChecksBold } from "react-icons/pi";

function Wrapper({ children, label, x, mioID, required, isInvalid, isTouched, checkbox = false }) {
    const style = {
        '--mio-form-wrapper-horizontal': `${x ?? 0}px`
    };
    const icon = useMemo(() => {
        if (!required) return '';
        if (!isTouched) return '*';
        if (!isInvalid) return <PiChecksBold />;
        return '*';
    }, [isTouched, isInvalid]);

    return (
        <div className={`
            mtwf group focus-within:group 
            ${x ? 'mio-form-wrapper-horizontal' : 'mio-form-wrapper-vertical'}
            ${checkbox ? x ? '' : 'mio-form-wrapper-checkbox-reversed' : ''}
            ${isInvalid ? 'mtwf-invalid' : ''}
            
            `}


            style={style}>
            <div className="mtwl">
                <label className="mio-form-label-element" htmlFor={mioID}>{label}</label>
                {/* {required && <span>*</span>} */}
                {icon}
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}
export default Wrapper